export default {
    reports:[],
    report:{},
    pagination:{
        total:0,
        current_page:0,
    },
}
